export default __webpack_public_path__ + "static/media/xanh.675ca243.jpg";